export const STATUS = {
  SUCCESS: "success",
  FAILURE: "failure",
  NONE: "none",
};

export const WebsocketURL = "wss://fuvosidebc.execute-api.us-east-1.amazonaws.com/dev";
